export let CalendarProvider = /*#__PURE__*/function (CalendarProvider) {
  CalendarProvider["GOOGLE"] = "GOOGLE";
  CalendarProvider["ICLOUD"] = "ICLOUD";
  CalendarProvider["MICROSOFT"] = "MICROSOFT";
  return CalendarProvider;
}({});
//# sourceMappingURL=CalendarProvider.js.map